import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import App from './App';

if (process.env.NODE_ENV === 'production') {
  console.log = () => { };
  console.info = () => { };
  console.warn = () => { };
  console.error = () => { };
}

// Registrar Service Worker para PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('[PWA] Service Worker registrado exitosamente:', registration.scope);
      })
      .catch((error) => {
        console.error('[PWA] Error al registrar Service Worker:', error);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
